<template>
  <div class="white pa-2 elevation-2">
    <img
      alt="Symbolforklaring for kart"
      height="150px"
      src="../../../assets/img/mapLegend.svg"
    />
  </div>
</template>

<script>
export default {
  name: "MapLegend",
};
</script>
